module.exports = __webpack_public_path__ + "static/media/eurofins.5e373769.png";